import { create } from "zustand";
import type { GeneratedReference, Reference } from "../api/infrastructure/reference.formatter";
import type { Settings } from "../api/infrastructure/settings.formatter";
import type { TableData } from "../api/infrastructure/table-data.formatter";
import type { TableColumnTypes } from "../api/infrastructure/table.formatter";
import type { Database } from "../helpers/format-databases";
import type { User } from "../helpers/format-users";
import type { AppLayout, DatabaseCreationInfo, ImportTableDataInputState } from "./store-types";

export interface AppStore {
  appLayout: AppLayout;
  setAppLayout: (appLayout: AppLayout) => void;

  isAuthenticated: boolean;
  setIsAuthenticated: (authenticated: boolean) => void;

  databases?: Database[];
  setDatabases: (databases?: Database[]) => void;

  generatedReferences?: GeneratedReference[];
  setGeneratedReferences: (generatedReferences?: GeneratedReference[]) => void;

  referenceDataById: Map<number, TableData[] | undefined>;
  setReferenceDataById: (databaseDataById: Map<number, TableData[] | undefined>) => void;

  users?: User[];
  setUsers: (users?: User[]) => void;

  authUser?: User;
  setAuthUser: (authUser: User | undefined) => void;

  settings?: Settings;
  setSettings(settings?: Settings): void;

  tableColumnTypes?: TableColumnTypes;
  setTableColumnTypes: (tableColumnTypes?: TableColumnTypes) => void;

  databaseCreationInfo?: DatabaseCreationInfo;
  setDatabaseCreationInfo: (databaseCreationInfo?: DatabaseCreationInfo) => void;

  importTableDataInputState?: ImportTableDataInputState;
  setImportTableDataInputState: (input?: ImportTableDataInputState) => void;

  referenceToEdit?: Reference;
  setReferenceToEdit: (reference?: Reference) => void;
}

export const useAppStore = create<AppStore>()((set) => ({
  appLayout: "desktop",
  setAppLayout: (appLayout) => set({ appLayout }),

  isAuthenticated: false,
  setIsAuthenticated: (authenticated) => set({ isAuthenticated: authenticated }),

  setDatabases: (databases) => set({ databases }),

  setGeneratedReferences: (generatedReferences) => set({ generatedReferences }),

  referenceDataById: new Map(),
  setReferenceDataById: (referenceDataById) => set({ referenceDataById }),

  setUsers: (users) => set({ users }),

  setAuthUser: (authUser) => set({ authUser }),

  setSettings: (settings) => set({ settings }),

  setTableColumnTypes: (tableColumnTypes) => set({ tableColumnTypes }),

  setDatabaseCreationInfo: (databaseCreationInfo?: DatabaseCreationInfo) =>
    set({ databaseCreationInfo }),

  setImportTableDataInputState: (input?: ImportTableDataInputState) =>
    set({ importTableDataInputState: input }),

  setReferenceToEdit: (reference?: Reference) => set({ referenceToEdit: reference }),
}));
